import { Badge } from "@musa.tech/design-system";
import type { ContestationStatus } from "@/integrations/contestacao/client";

/**
 * `CORRECTION_PENDING` é o estado em que a Musa já decidiu e a correção está sendo aplicada nos
 * outros sistemas — daí o rótulo de processamento, e não de conclusão.
 *
 * `EXPIRED` é a contestação que passou do prazo sem conclusão da Musa: neutra de propósito, porque
 * não é recusa nem aceite — ninguém decidiu.
 */
const statusConfig: Record<
  ContestationStatus,
  { label: string; variant: 'info' | 'warning' | 'success' | 'destructive' | 'secondary' }
> = {
  OPEN:                { label: 'Aberta',                       variant: 'info' },
  IN_ANALYSIS:         { label: 'Em análise',                   variant: 'info' },
  AWAITING_INFO:       { label: 'Aguardando suas informações',  variant: 'warning' },
  ACCEPTED:            { label: 'Aceita',                       variant: 'success' },
  PARTIALLY_ACCEPTED:  { label: 'Aceita parcialmente',          variant: 'success' },
  REJECTED:            { label: 'Rejeitada',                    variant: 'destructive' },
  CORRECTION_PENDING:  { label: 'Correção em processamento',    variant: 'info' },
  CORRECTION_APPLIED:  { label: 'Correção aplicada',            variant: 'success' },
  EXPIRED:             { label: 'Vencida',                      variant: 'secondary' },
};

interface ContestationStatusBadgeProps {
  status: ContestationStatus;
}

export function ContestationStatusBadge({ status }: ContestationStatusBadgeProps) {
  const config = statusConfig[status];
  if (!config) return null;
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
